<div
  #areaBackgroundContainer
  class="relative flex items-center justify-center w-full h-full"
  [ngClass]="{
    'h-full': isBackgroundFileHTMLSig() || isBackgroundFileCubemapSig(),
    'max-w-[calc(100vh*16/9)] aspect-[16/9]': !isBackgroundFileHTMLSig() && !isBackgroundFileCubemapSig(),
  }"
>
  @if (backgroundFile) {
    @if (isBackgroundFileCubemapSig()) {
      <nrc-area-background-360-degree
        class="absolute top-0 left-0 w-full h-full"
        [apiBaseUrl]="apiBaseUrl"
        [backgroundFile]="backgroundFile"
        [areaElements]="areaElements"
        [currentLanguageCode]="currentLanguageCodeSig()"
        [selectedAreaElementConfig]="selectedAreaElementConfig"
        [parentContainer]="areaBackgroundContainerRef"
        (areaElementBoundingBoxChange)="handleAreaElementBoundingBoxChange($event)"
        (areaElementClickedEvent)="areaElementClickedEvent.emit($event)"
        (areaElementDblClickedEvent)="areaElementDblClickedEvent.emit($event)"
        (areaElementClickOutsideEvent)="areaElementService.areaElementSelectedSig.set(null)"
      />
    } @else if (isBackgroundFileHTMLSig()) {
      <nrc-html-background
        class="absolute top-0 left-0 w-full h-full"
        [backgroundFile]="backgroundFile"
        [apiBaseUrl]="apiBaseUrl"
        [areaElements]="areaElements"
        (loadComplete)="onBackgroundLoadComplete()"
        (areaElementMetadataChanged)="areaElementChangedEvent.emit($event)"
      />
    }
    @else {
      <nrc-area-background-2d
        class="absolute top-0 left-0 w-full h-full"
        [apiBaseUrl]="apiBaseUrl"
        [backgroundFile]="backgroundFile"
        [isEditMode]="isEditMode"
        (mediaLoaded)="onBackgroundLoadComplete()"
      />
    }
  } @else {
    <nrc-area-background-empty
      (changeBackgroundEvent)="changeBackgroundEvent.emit()"
    />
  }

  @if ((areaElements | isNonEmptyArray) && areaElements && !isBackgroundFileCubemapSig()) {
    <div class="relative flex flex-col w-full h-full pointer-events-none overflow-hidden">
      @for (areaElement of areaElements; let i = $index; track areaElement.id) {
        @if (areaElement && !areaElement.markedForDeletion && areaBackgroundContainerRef) {
          <nrc-scene-overlay
            [id]="areaElement.id"
            [boundingBox]="areaElement.boundingBox"
            [parentContainerRef]="areaBackgroundContainerRef"
            [zIndex]="(areaElements.length + 1) - i"
            (boundingBoxChanged)="handleAreaElementBoundingBoxChange({ id: areaElement.id, boundingBox: $event })"
            [isEditMode]="isEditMode"
            [isLocked]="areaElement.isLocked"
            [isResizable]="areaElementService.areaElementSelectedSig()?.id === areaElement.id && !!selectedAreaElementConfig?.isResizableStatus"
            [keepAspectRatio]="areaElementService.areaElementSelectedSig()?.id === areaElement.id && !!selectedAreaElementConfig?.keepAspectRatio"
            [style.display]="areaElement.metadata && areaElement.metadata.htmlElementId ? 'none' : 'block'"
          >

            <nrc-area-element
              #areaElementContainer
              class="w-full h-full"
              nrcClickOutside
              [isClickOustiseEnabled]="isEditMode && (areaElementService.areaElementSelectedSig()?.id === areaElement.id && !!selectedAreaElementConfig?.isResizableStatus)"
              [excludeQuerySelector]="['[data-overlay-ui]']"
              [targetContainerElement]="areaBackgroundContainer"
              [languageCode]="currentLanguageCodeSig()"
              [isResizable]="isEditMode && (selectedAreaElementConfig?.isResizableStatus ?? false)"
              [apiBaseUrl]="apiBaseUrl"
              [areaElement]="areaElement"
              [editMode]="isEditMode"
              [parentContainerElement]="areaBackgroundContainer"
              [style.pointer-events]="'all'"
              [style.visibility]="areaElement.isEnabled ? 'visible' : 'hidden'"
              (clickEvent)="handleAreaElementClickEvent(areaElement)"
              (doubleClickEvent)="areaElementDblClickedEvent.emit(areaElement)"
              (clickOutsideEvent)="areaElementService.areaElementSelectedSig.set(null)"
            />
          </nrc-scene-overlay>
        }
      }
    </div>
  }
</div>
